import styles from './styles.module.scss';
import { CommonModalsKey } from '@starsoft/common/enums';
import { useModalNavigation, useTranslation } from '../../../../hooks';
import { Link } from '@starsoft/common/components/Link';

/**
 * TransactionResultActions Component
 * Renders a button that links to the support modal, allowing users to ask questions
 * about their transaction.
 *
 * @component
 * @returns {JSX.Element} A container with a link button to the support modal
 *
 * @example
 * <TransactionResultActions />
 */
export default function TransactionResultActions() {
  const { t } = useTranslation('deposit');
  const { getModalLink } = useModalNavigation();

  return (
    <div className={styles.container}>
      <Link
        href={getModalLink(CommonModalsKey.SupportModal)}
        className={styles.container__link}
      >
        <button className={styles.container__button}>
          <i
            className={`${styles.container__button__icon} fa-solid fa-message-question`}
          />

          <span className={styles.container__button__label}>
            {t('ask_a_question')}
          </span>
        </button>
      </Link>
    </div>
  );
}
